const renderPhotoSlider = ($) => {
	let comparisonSlider = $(".js__photo-slider__container__slider");

	comparisonSlider.each(function (index) {
		let eachSlider = $(this);
		let input = eachSlider.children("input");
		let beforeImg = eachSlider.children(
			".js__photo-slider__container__slider__image--before"
		);

		input.on("input change", function (ev) {
			let sliderValue = ev.target.value + "%";

			$(comparisonSlider[index])
				.children(".js__photo-slider__container__slider__image--before")
				.css("width", ev.target.value + "%");
			if(sliderValue === "100%") {
				beforeImg.css({"border-top-right-radius": "20px",
					"border-bottom-right-radius": "20px"});
			} else {
				beforeImg.css({"border-top-right-radius": "0px",
					"border-bottom-right-radius": "0px"});
			}
		});

	});
};

export default renderPhotoSlider;
